<template>
    <div  v-if="element != null">

        <div class="row d-block">
            <div id="header-body-chat">
                <div class="col-12">
                    <div class="row">
                        <div class="col-10 d-flex align-items-center">
                            <div class="circle-body-chat d-flex align-items-center justify-content-center">
                                <ficon :icon="['fa', 'comment-alt']" v-if="element.channel == 'chat'" size="2x"></ficon>
                                <ficon :icon="['fa', 'sms']" v-if="element.channel == 'sms'" size="2x"></ficon>
                                <ficon :icon="['fab', 'whatsapp']" v-if="element.channel == 'whatsapp'" size="2x"></ficon>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="title-header-chat float-left">
                                        {{element.name}}  <i class="typing-message" v-if="typingMessage == true"> - sta scrivendo..</i>
                                    </div>
                                    <br v-if="element.argomento != null">
                                    <div  v-if="element.argomento != null" class="text-reparto float-left"><i>{{element.reparto}} - {{element.argomento}}</i></div>
                                    <br>
                                    <div class="text-last-message float-left"><i>Ultimo messaggio: {{element.last_message}}</i></div>
                                </div>
                            </div>
                        </div>
                        <div class="col-1 d-flex align-items-center justify-content-end">
                            <div class="row">
                                <div class="col-12">
                                    <ficon :icon="['fa', 'info-circle']" class="color-icon-white icon-info mt-2" @click="showInfoChat(element.id)"></ficon>
                                </div>
                            </div>
                        </div>
                        
                         <div class="col-1">
                            <div class="row">
                                <div class="col-12" v-if="typeChat == 0">
                                    
                                    <b-nav-item-dropdown no-caret class="m-2 unstyled font-22">
                                        <!-- Using 'button-content' slot -->
                                        <template slot="button-content">
                                            <ficon :icon="['fas', 'ellipsis-v']" class="color-icon-white"></ficon>
                                        </template>
                                        <b-dropdown-item @click="rilascia(element.id)">Rilascia</b-dropdown-item>
                                        <b-dropdown-item @click="chiudi(element.id)">Chiudi</b-dropdown-item>
                                    </b-nav-item-dropdown>
                                </div>
                                <div class="col-12 d-flex align-items-center" v-if="typeChat == 1">
                                    <b-nav-item-dropdown no-caret class="m-2 unstyled font-22">
                                        <!-- Using 'button-content' slot -->
                                        <template slot="button-content">
                                            <ficon :icon="['fas', 'ellipsis-v']" class="color-icon-white"></ficon>
                                        </template>
                                        <b-dropdown-item @click="inCarico(element)">Prendi in Carico</b-dropdown-item>
                                    </b-nav-item-dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row d-block">
            <div id="body-message-chat">
                <div class="col-12" v-if="countChat < countAllChat">
                    <a href="javascript:void(0)" title="Mostra Altri Messaggi" @click="showOtherMessage(element.id)">
                        <ficon :icon="['fas', 'arrow-circle-up']" class="color-convergenze" size="2x"></ficon>
                    </a>
                </div>
            
                <div class="col-12 content-message" v-for="(value , key) in this.list_message" v-bind:key="key">
                    <card-message :element="value"></card-message>
                </div>
            </div>
        </div>
        <div class="row">
            <div id="body-send-message">
                <div class="col-12">
                    <input type="file"  ref="inputFile" id="file-attached" style="display:none" v-on:change="onFilePicked">
                    <div class="pl-1 text-left d-flex" v-if="this.showAttach == true">
                        <p>
                            {{attach}}
                            <ficon :icon="['fa', 'trash']" class="ml-1 color-icon icon-pointer" v-on:click="deleteAttach"></ficon>
                        </p>
                    </div>
                </div>
                <div id="list-suggerimenti" :class="{ 'list-suggerimenti-show' : this.showSuggerimenti == true}">
                    <div class="row w-100">
                        <div class="col-12">
                            <ul v-for="(value , key) in this.list_suggerimenti" v-bind:key="key" class="text-left unstyled">
                                <li class="suggerimento" v-on:click="setSuggerimento(value.text)" ><span v-html="value.label"></span></li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div id="list-suggerimenti" :class="{ 'list-suggerimenti-show' : this.showLinkArea == true}">
                    <div class="row w-100">
                        <div class="col-1">
                        </div>
                        <div class="col-10 text-left">
                            <label>Inserisci Link</label>
                            <input type="text" class="form-control" name="input-link" id="input-link" v-model="linkMessage" v-html="linkMessage">
                        </div>
                        <div class="col-1">
                            
                            <button type="button" style="margin-top:35px" class="btn btn-sm btn-primary" v-on:click="setLinkArea()">
                                <strong>+</strong>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-12 d-flex" v-if="typeChat == 0">
                    <div class="row d-block">
                        <button type="button" class="btn" v-on:click="openSuggrimenti()">
                            <ficon :icon="['fas', 'font']" class="color-icon"></ficon>
                        </button>
                        <button type="button" class="btn" v-on:click="openLinkArea()">
                            <ficon :icon="['fas', 'link']" class="color-icon"></ficon>
                        </button>
                    </div>
                    <textarea type="text" class="form-control" ref="input-message" id="input-message" v-model="message" v-html="message" placeholder="Scrivi il tuo messaggio" rows="3" v-on:blur="resetTypingMessage" v-on:keypress="funTypingMessage" v-on:keyup.enter="sendMessage"  ></textarea>
                    <button type="button" class="btn" v-on:click="sendMessage">
                        <ficon :icon="['fas', 'paper-plane']" class="color-icon"></ficon>
                    </button>
                    <button type="button" class="btn" v-on:click="attachFile">
                        <ficon :icon="['fas', 'paperclip']" class="color-icon"></ficon>
                    </button>
                </div>
                <div class="col-12 d-flex" v-if="typeChat != 0">
                    <input type="text" class="form-control" placeholder="Scrivi il tuo messaggio" disabled>
                    <button type="button" class="btn" disabled>
                        <ficon :icon="['fas', 'paper-plane']" class="color-icon"></ficon>
                    </button>
                    <button type="button" class="btn" disabled>
                        <ficon :icon="['fas', 'paperclip']" class="color-icon"></ficon>
                    </button>
                    
                </div>
                
            </div>
            <b-modal id="modal-sm" ref="my-modal" title="Info Chat Utente">
                <div class="row" v-if="this.info.account != null">
                    <div class="col-md-4">
                        <strong>Account:</strong>
                    </div>
                    <div class="col-md-8">
                        <a :href="this.info.link_account" target="_blank" id="link-account">{{this.info.account}}</a>
                    </div>
                </div>
                <div class="row" v-if="this.info.data_scadenza != null">
                    <div class="col-md-4">
                        <strong>Scadenza Chat:</strong>
                    </div>
                    <div class="col-md-8">
                        <span id="data-scadenza-chat">{{this.info.data_scadenza}}</span>
                    </div>
                </div>
                <div class="row" v-if="this.info.channel != null">
                    <div class="col-md-4">
                       <strong>Channel:</strong>
                    </div>
                    <div class="col-md-8">
                        <span id="data-scadenza-chat">{{this.info.channel}}</span>
                    </div>
                </div>
                <div class="row" v-if="this.info.sito_web != null">
                    <div class="col-md-4">
                       <strong>Pagina SitoWeb:</strong>
                    </div>
                    <div class="col-md-8">
                        <a :href="this.info.link_sito" target="_blank" id="link-account">{{this.info.sito_web}}</a>
                    </div>
                </div>
                <div v-if="this.info.sito_web == null && this.info.account == null && this.info.data_scadenza == null && this.info.channel == null">
                    Nessuna Informazione Presente
                </div>
            </b-modal>
            
        </div>
    </div>
</template>

<script>

    //import BackendApi from '../models/BackendApi'
    import CardMessage from '@/components/CardMessage.vue'
    import defapp from '../models/defapp.js'
    import MessageChat from '../models/MessageChat'
    import BackendApi from '../models/BackendApi'

    export default {
        name: 'BodyChat',
        data: function() {
            return  {
                message: "",
                attach: "",
                showAttach: false,
                file: null,
                writeTypingMessage: false,
                showSuggerimenti: false,
                showLinkArea: false,
                endChatD: false,
                linkMessage: "",
                info: {
                    account : null,
                    link_account: "#",
                    data_scadenza: "",
                    sito_web: null,
                    link_sito: "#",
                    channel: null,
                    
                }

                
            };
        },
        components: {    
            CardMessage
        },
        props: ['element','list_message','typeChat','callbackInCarico','callbackRilascia','callbackChiudi','showChat','countChat','countAllChat','list_suggerimenti','client','typingMessage','endChat'],
        methods: {       
            sendMessage()
            {
                let type =  MessageChat.TYPE_MESSAGE
                this.message = this.message.replace( /\n/gi , "<br>");
                if(this.file == null)
                {
                    let msg = new MessageChat()
                    let prepareMessage = msg.prepareSendMessage(type,this.element.staff_id,this.message,"",this.element.id,defapp.TYPE_MESSAGE_SENT)
                    this.client.sendMessage(prepareMessage)

                } else {
                    let api = new BackendApi(this.configApp)
                    let formData = new FormData();
                    formData.append('file' , this.file)
                    formData.append('type' , type)
                    formData.append('staff_id' , this.element.staff_id)
                    formData.append('user_id' , this.element.staff_id)
                    formData.append('message' , this.message)
                    formData.append('chat_id' , this.element.id)
                    formData.append('type_message' , defapp.TYPE_MESSAGE_SENT)

                    api.saveMessageAttach(formData, (result) => {
                        if(result.success)
                        {
                            let msg = new MessageChat()
                            let prepareMessage = msg.prepareSendMessage(type,this.element.staff_id,this.message,"",this.element.id,defapp.TYPE_MESSAGE_SENT,"",result.message_id)
                            this.client.sendMessage(prepareMessage)
                            this.file = null
                            this.showAttach = false
                        }
                    })
                }

                
                this.message = ""
            },
            inCarico: function(element) {
                this.endChatD = false
                this.callbackInCarico(element,1,defapp.TYPE_CHAT_ASSIGNED); 
            },
            rilascia: function(chat_id) {
                this.endChatD = true
                this.callbackRilascia(chat_id,1,defapp.TYPE_CHAT_NOT_ASSIGNED); 
            },
            chiudi: function(chat_id) {
                this.endChatD = true
                this.callbackChiudi(chat_id,1,defapp.TYPE_CHAT_ARCHIVED)
            },
            showOtherMessage: function(chat_id)
            {
                let new_limit = this.countChat + defapp.LIMIT_MESSAGE;
                console.log(new_limit,chat_id);
                this.showChat(this.element,this.typeChat,new_limit)
            },
            resetTypingMessage: function()
            {
                this.writeTypingMessage = false
            },
            funTypingMessage: function()
            {
                let input = document.getElementById("input-message").value
                
                if(input.length > 2 && this.writeTypingMessage == false)
                {
                    let type = MessageChat.TYPE_TYPING_MESSAGE
                    
                    let msg = new MessageChat()
                    this.client.sendMessage(msg.prepareSendMessage(type,this.element.staff_id,"Sta scrivendo...","",this.element.id,defapp.TYPE_MESSAGE_SENT))
                    this.writeTypingMessage = true
                } 
            },
            attachFile: function() {
                document.getElementById('file-attached').click()
            },
            onFilePicked(e) {
                this.showAttach = false;
                let files = e.target.files
                if (files[0] !== undefined) {
                    this.files = files[0];
                    this.attach = files[0].name;
                    this.showAttach = true;
                    this.file = this.$refs.inputFile.files[0]
                }
            },
            deleteAttach()
            {
                this.showAttach = false;
                this.attach = "";
                this.$refs.inputFile.files = null;
                this.file = null
            },
            showInfoChat(chat_id)
            {

                let api = new BackendApi(this.configApp)
                api.infoChat(chat_id,(result) => {
                    if(result.success != false)
                    {
                        this.info.account = result.account
                        this.info.link_account = result.link_account
                        this.info.data_scadenza = result.data_scadenza
                        this.info.channel = result.channel
                        this.info.sito_web = result.sito_web
                        this.info.link_sito = result.link_sito_web
                    }
                
                });

                this.$refs['my-modal'].show()
            },
            openSuggrimenti()
            {
               
                if(this.showSuggerimenti == true)
                {
                    this.showSuggerimenti = false;
                } else {
                    this.showSuggerimenti = true;
                }
            },
            setSuggerimento(text)
            {
                this.message = ""
                text = text.replace(/<br>/gi , "\n");
                this.message = text
                this.showSuggerimenti = false;
            },
            openLinkArea()
            {
                 if(this.showLinkArea == true)
                {
                    this.showLinkArea = false;
                } else {
                    this.showLinkArea = true;
                }
            },
            setLinkArea()
            {

                var href = " <a href=\""+this.linkMessage+"\" target=\"_blank\">"+this.linkMessage+"</a> "
                
                this.message = this.message + href
                this.linkMessage = ""
            }
           
            
        },
        computed: function(){  
            
        },
        mounted: function(){
           
        },
        created: function() { 
            
        },
    }
</script>